import { memo, type FC } from 'react';
import { Modal } from 'Modal';
import Button from 'Button';
import { Text } from 'Text';

type ExitModalProps = {
    text: string;
    title: string;
    cancelLabel: string;
    confirmLabel: string;
    onCancel: () => void;
    onConfirm: () => void;
    isMobile: boolean;
};

const ExitModalComponent: FC<ExitModalProps> = ({
    text,
    title,
    cancelLabel,
    confirmLabel,
    onCancel,
    onConfirm,
    isMobile,
}) => (
    <Modal onClose={onCancel} dismissOnOverlayClick={false} hideCloseButton title={title} titleAlignment="start">
        {({ closeModal }) => (
            <div className="px-7 pb-7">
                <Text color="black" className="mb-8 text-start">
                    {text}
                </Text>
                <div className="flex flex-wrap justify-center gap-4 sm:flex-nowrap sm:justify-end">
                    <Button
                        onPress={() => {
                            closeModal();
                            onConfirm();
                        }}
                        color="slate-grey"
                        height={12.5}
                        tabletHeight={9}
                        fullWidth={isMobile}
                    >
                        {confirmLabel}
                    </Button>
                    <Button
                        onPress={() => {
                            closeModal();
                            onCancel();
                        }}
                        color="primary-gradient"
                        height={12.5}
                        tabletHeight={9}
                        fullWidth={isMobile}
                    >
                        {cancelLabel}
                    </Button>
                </div>
            </div>
        )}
    </Modal>
);

export const ExitModal = memo(ExitModalComponent) as typeof ExitModalComponent;
